import css from 'styled-jsx/css';

const styles = css.global`.modal-voucher {
  padding: calc(40px - 24px) 0;
}

.modal-voucher .text-title {
  color: #222;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  margin: 0 0 32px;
}

.modal-voucher .info-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 16px;
  border-radius: 4px;
  background: #f5f9fb;
  gap: 8px;
  min-height: 130px;
  margin: 32px 0 80px;
}

.modal-voucher .info-box .text-desc {
  color: #222;
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;
  max-width: 128px;
}

.modal-voucher .sn-button.white {
  margin-top: 16px;
}

.modal-voucher .text-title-desk {
  display: none;
}

.modal-voucher .field-wrapper {
  margin: 30px 0;
}

.modal-voucher .field-wrapper.valid .text-field .text-field__label.floating {
  color: #739e41;
}

@media (min-width: 992px) {
  .modal-voucher {
    padding: 0;
    height: 100%;
  }

  .modal-voucher .text-title-desk {
    display: block;
    max-width: calc(100% - 48px);
    color: #222;
    margin: 0;
    font-family: SantanderHeadline;
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0%;
  }

  .modal-voucher .text-title {
    margin: 22px 0 30px;
  }

  .modal-voucher .field-wrapper {
    margin-top: 0;
  }

  .modal-voucher .ctn-home-24 {
    padding: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .modal-voucher .btn-wrapper {
    display: block;
    margin-top: auto;
  }

  .modal-voucher .info-box .text-desc {
    max-width: 224px;
  }

  .modal-voucher .sn-button.white {
    display: none !important;
  }
}
`;

export default styles;